import { render } from "./ViewUserModal.vue?vue&type=template&id=50d962ce&scoped=true"
import script from "./ViewUserModal.vue?vue&type=script&lang=js"
export * from "./ViewUserModal.vue?vue&type=script&lang=js"

import "./ViewUserModal.vue?vue&type=style&index=0&id=50d962ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d962ce"]])

export default __exports__